import React from "react";
import ChartItem from "./ChartItem";
import { adaptDataPieChart, buildSingleDataArrays, getSum } from "./utils";
import { createUniqueKey } from "../../../utils";
import withTheme from "../../../hocs/withTheme";

import "./PieChart.css";

function PieChartSA({
    data = [],
    numberFormat = (num) =>
        num.toLocaleString("en-US", { minimumFractionDigits: 2 }),
    percentFormat = (num) =>
        `${num.toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
}) {
    const chartData = data.length >= 6 ? adaptDataPieChart(data, 6) : data;
    const sum = getSum(chartData);

    return (
        <div className="PieChart">
            {buildSingleDataArrays(
                chartData,
                sum
            ).map((item, index) => (
                <ChartItem
                    key={createUniqueKey(index, item[0]?.name || 'chart-item')}
                    index={index}
                    data={item}
                    sum={sum}
                    numberFormat={numberFormat}
                    percentFormat={percentFormat}
                    singleAllocation
                />
            ))}
        </div>
    );
}


export default withTheme(PieChartSA);
